import React, { useEffect, useState } from "react";
import { Sidebar } from "../../components/Sidebar";
import { Header } from "../../components/Header";
import { Load } from "../../components/Load";
import { Main } from "../../components/Main";
import { CardContent } from "../../components/CardContent";
import { Title } from "../../components/Title";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { TBody, TCell, TGroup, THeader, TRow, Table } from "../../components/Table/Table";
import { FillPen } from "../../components/Icons";
import api from "../../services/api";
import './style.css';

interface CredenciadoSelecionado {
    id: number;
    nome: string;
    porcentagem_comissao: number;
    edit: boolean;
}

interface RepresentanteComercialSelecionado {
    id: number;
    nome: string;
    credenciado_responsavel: string;
    porcentagem_comissao: number;
    id_credenciado: number;
    nome_credenciado: string;
    edit: boolean;
}


export const Comissoes = () => {
    const [isLoading] = useState(false);
    const [credenciados, setCredenciados] = useState<CredenciadoSelecionado[]>([]);
    const [representantesComerciais, setRepresentantesComerciais] = useState<RepresentanteComercialSelecionado[]>([]);
    const [porcentagemComissao, setPorcentagemComissao] = useState(0);
    const [porcentagemComissaoRepresentantes, setPorcentagemComissaoRepresentantes] = useState(0);

    useEffect(() => {
        handleGetRepresentantesComerciais();
    }, []);

    const handleGetRepresentantesComerciais = async () => {
        let response = await api.get(`listar-credenciados`);
        const credenciados = response.data as CredenciadoSelecionado[];
        setCredenciados(credenciados.map(cred => ({ ...cred, edit: false })));

        response = await api.get(`listar-todos-representantes`);
        const representantesComerciais = response.data as RepresentanteComercialSelecionado[];
        const representantesComerciaisCompletos = representantesComerciais.map(rep => {
            const nomeCredenciado = credenciados.find(cred => cred.id === rep.id_credenciado)?.nome || 'Não encontrado';
            return { ...rep, nome_credenciado: nomeCredenciado, edit: false };
        });
        setRepresentantesComerciais(representantesComerciaisCompletos);
    }

    const handleSaveRepresentantesComerciais = async (index: number) => {
        const representanteComercial = representantesComerciais[index];
        if (representanteComercial.porcentagem_comissao !== porcentagemComissaoRepresentantes) {
            representanteComercial.porcentagem_comissao = porcentagemComissaoRepresentantes;
            await api.put('atualizar-comissoes-representantes-comerciais', representanteComercial);
        }
        handleEditRepresentantesComerciais(index);
    }
    const handleSave = async (index: number) => {
        const credenciado = credenciados[index];
        if (credenciado.porcentagem_comissao !== porcentagemComissao) {
            credenciado.porcentagem_comissao = porcentagemComissao;
            await api.put('atualizar-comissoes-credenciados', credenciado);
        }
        handleEdit(index);
    };

    const handleCancelEdit = (index: number) => {
        handleEdit(index);
    };

    const handleCancelEditRepresentantesComerciais = (index: number) => {
        handleEditRepresentantesComerciais(index);
    }
    const handleEdit = (index: number) => {
        setCredenciados((prevState) => {
            const updatedCredenciados = [...prevState];
            updatedCredenciados[index].edit = !updatedCredenciados[index].edit;
            return updatedCredenciados;
        });
    };

    const handleEditRepresentantesComerciais = (index: number) => {
        setRepresentantesComerciais((prevState) => {
            const updatedRepresentantesComerciais = [...prevState];
            updatedRepresentantesComerciais[index].edit = !updatedRepresentantesComerciais[index].edit;
            return updatedRepresentantesComerciais;
        });
    }
    return (
        <>
            {!isLoading && (
                <>
                    <Sidebar />
                    <Header route='./' />
                    <Main>
                        <CardContent>
                            <Title text="Editar Comissões - Credenciados" />
                            <Load isLoading={isLoading} />

                            {credenciados.length > 0 ? (
                                <>
                                    <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                        <div style={{ overflow: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                        <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Credenciado</th>
                                                        <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Porcentagem de Comissão</th>
                                                        <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {credenciados.map((credenciado, index) => (
                                                        <tr key={credenciado.id} style={{ textAlign: 'center' }}>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{credenciado.nome}</td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {credenciado.edit ? (
                                                                    <input
                                                                        type="number"
                                                                        className='editInput'
                                                                        value={porcentagemComissao}
                                                                        onChange={(e) => {
                                                                            const newValue = parseFloat(e.target.value.trim());
                                                                            setPorcentagemComissao(newValue);
                                                                        }}
                                                                        style={{ width: '80%', padding: '5px', textAlign: 'center' }}
                                                                    />
                                                                ) : (
                                                                    credenciado.porcentagem_comissao ? `${credenciado.porcentagem_comissao}%` : 'Nenhuma Definida'
                                                                )}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', borderTop: '1px solid lightgray' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                    {credenciado.edit ? (
                                                                        <>
                                                                            <Button onClick={() => handleSave(index)}>Salvar</Button>
                                                                            <Button variant='secondary' onClick={() => handleCancelEdit(index)}>Cancelar</Button>
                                                                        </>
                                                                    ) : (
                                                                        <Button className='btn btn-outline-primary btn-outline-main' style={{ float: 'right' }} onClick={() => handleEdit(index)}>
                                                                            Editar<FillPen />
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <Col className="d-flex justify-content-center" style={{ marginTop: '20px' }}>
                                    <Row>
                                        <Alert variant="danger" className="text-center">Nenhum Credenciado Encontrado!</Alert>
                                    </Row>
                                </Col>
                            )}
                        </CardContent>

                        <CardContent>
                            <Title text="Editar Comissões - Representantes Comerciais" />
                            <Load isLoading={isLoading} />

                            {representantesComerciais.length > 0 ? (
                                <>
                                    <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                        <div style={{ overflow: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                        <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Representantes Comercial</th>
                                                        <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Credenciado Responsável</th>
                                                        <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Porcentagem de Comissão</th>
                                                        <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {representantesComerciais.map((representanteComercial, index) => (
                                                        <tr key={representanteComercial.id} style={{ textAlign: 'center' }}>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{representanteComercial.nome}</td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{representanteComercial.nome_credenciado}</td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {representanteComercial.edit ? (
                                                                    <input
                                                                        type="number"
                                                                        className='editInput'
                                                                        value={porcentagemComissaoRepresentantes}
                                                                        onChange={(e) => {
                                                                            const newValue = parseFloat(e.target.value.trim());
                                                                            setPorcentagemComissaoRepresentantes(newValue);
                                                                        }}
                                                                        style={{ width: '80%', padding: '5px', textAlign: 'center' }}
                                                                    />
                                                                ) : (
                                                                    representanteComercial.porcentagem_comissao ? `${representanteComercial.porcentagem_comissao}%` : 'Nenhuma Definida'
                                                                )}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                    {representanteComercial.edit ? (
                                                                        <>
                                                                            <Button onClick={() => handleSaveRepresentantesComerciais(index)}>Salvar</Button>
                                                                            <Button variant='secondary' onClick={() => handleCancelEditRepresentantesComerciais(index)}>Cancelar</Button>
                                                                        </>
                                                                    ) : (
                                                                        <Button className='btn btn-outline-primary btn-outline-main' style={{ float: 'right' }} onClick={() => handleEditRepresentantesComerciais(index)}>
                                                                            Editar<FillPen />
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <Col className="d-flex justify-content-center" style={{ marginTop: '20px' }}>
                                    <Row>
                                        <Alert variant="danger" className="text-center">Nenhum Representante Comercial Encontrado!</Alert>
                                    </Row>
                                </Col>
                            )}
                        </CardContent>
                    </Main>
                </>
            )}
        </>
    );
}

export default Comissoes;